import React from 'react';
import styles from './Link.module.scss';
import {ReactComponent as Arrow} from '../../assets/arrow.svg';
import { mergeClassNames } from '../../utils/mergeClassNames';
import { GLOBAL } from '../../App';
import ObjectUtils from '../../utils/ObjectUtils';

interface LinkProps {
	decoration?:boolean,
	arrow?:boolean,
	disabled?:boolean,
}

export class Link extends React.Component<LinkProps & React.DetailedHTMLProps<React.AnchorHTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement>>
{

	static defaultProps = {
		decoration: true,
		arrow: true,
		disabled: false,
	}


	private _onClick = (e) =>
	{
		if(GLOBAL.router?.exists(this.props['href'] as string) && !this.props['target'])
		{
			e.preventDefault();
			GLOBAL.router?.goto(GLOBAL.router?.normalize(this.props['href']));
		}else
		{
		}

		this.props['onClick']?.apply(this, [e])
	}

	render()
	{
		let props:any = ObjectUtils.filter(this.props, ['arrow', 'decoration'], true);
		props['onClick'] = this._onClick;
		if(GLOBAL.router?.exists(props['href']))
		{
			props['href'] = GLOBAL.router?.normalize(props['href']);
		}else
		{
			if(!props['target']) props['target'] = '_blank'
		}

		return (
			<a {...props} className={mergeClassNames([props['className'], 'link', (!this.props.decoration)?'no-decoration':null, (this.props.disabled)?'disabled':null], styles)}>
				{this.props['children']}
				{this.props.arrow && !this.props.disabled?(<Arrow className={mergeClassNames(['arrow'], styles)}></Arrow>):null}
			</a>
		);
	}
}